export function deriveDisplayName(c) {
  const claim = (typ) => c.claims?.find((x) => x.typ === typ || String(x.typ ?? '').endsWith(`/${typ}`))?.val
  const full = claim('name')
  if (full && !full.includes('@')) return full
  const given = claim('given_name')
  const family = claim('family_name')
  if (given || family) return [given, family].filter(Boolean).join(' ')
  const prefix = String(c.userDetails ?? '').split('@')[0]
  return prefix
    .split(/[._-]/)
    .filter(Boolean)
    .map((p) => p[0]?.toUpperCase() + p.slice(1))
    .join(' ') || c.userDetails || 'Nutzer'
}

async function safeJson(res) {
  if (!res) return null
  try {
    return await res.json()
  } catch {
    return null
  }
}

export async function loadAuthSession(fetchImpl = globalThis.fetch) {
  const meRes = await fetchImpl('/.auth/me', { credentials: 'include' }).catch(() => null)
  const me = meRes && meRes.ok ? await safeJson(meRes) : null
  const principal = me?.clientPrincipal ?? null

  const rolesRes = await fetchImpl('/api/my-roles', {
    method: 'POST',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(principal ?? {}),
  }).catch(() => null)
  const rolesBody = rolesRes && rolesRes.ok ? await safeJson(rolesRes) : null
  const roles = Array.isArray(rolesBody?.roles)
    ? rolesBody.roles
    : Array.isArray(principal?.userRoles)
      ? principal.userRoles
      : []

  if (!principal) return { user: null, principal: null, roles }

  const user = {
    ...principal,
    userRoles: roles,
    displayName: deriveDisplayName({ ...principal, userRoles: roles }),
  }
  return { user, principal, roles }
}

